import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import "../style/component/modal.css";
import Close from "../assets/image/close-icon.png";
import PlusIcon from "../assets/image/plus.svg";
import QtyOR from "../assets/image/qtyOR.svg";
import MinusIcon from "../assets/image/minus.svg";
import { Link, useNavigate } from "react-router-dom";
import GreenCoin from "../assets/image/coin-icon-green.png";
import Success from "../assets/image/success-icon.png";
import IR1 from "../assets/image/IR-1.svg";
import IR2 from "../assets/image/IR-2.svg";
import IR3 from "../assets/image/IR-3.svg";
import RightAerrow from "../assets/image/rightAerrow.svg";
import AlertIcon from "../assets/image/alertIcon.svg";
import Like from "../assets/image/like.svg";
import { toast } from "react-toastify";
import StripeComponent from "../component/lms/stripeComp";
import "../style/component/profile.css";
import HttpService from "./https.services";
import { Get, Postdata } from "./api.services";
import { EVENTS, trackEvent } from "../component/mixpanel";
import moment from "moment";
import { AF_EVENTS, trackAFEvent } from "../component/appsflyer";

export const isSingleAssetContest = (contestDetails) => {
  if (!contestDetails) return false;
  const selectedStocks = contestDetails.selected_stocks;
  return Array.isArray(selectedStocks) && selectedStocks.length === 1;
};

export const shouldSkipQuantityModal = (contestDetails, type) => {
  if (!contestDetails) return false;
  return true;
};

export const buildPortfolioStockPayload = ({
  data,
  qty,
  selectedPortfoilo = [],
  contestDetails,
  mode,
  uniqueAssetSelection = false,
}) => {
  const formValue = qty || 1;

  if (uniqueAssetSelection && formValue > 1) {
    toast.error("Each asset can only be selected once");
    return null;
  }

  if (contestDetails) {
    const safeSelected = selectedPortfoilo || [];
    const bullishStocks = safeSelected.filter(
      (stock) => stock.type === "bullish"
    );
    const bearishStocks = safeSelected.filter(
      (stock) => stock.type === "bearish"
    );

    let totalBullishQty = bullishStocks.reduce(
      (total, stock) => total + (Number(stock.qty) || 1),
      0
    );
    let totalBearishQty = bearishStocks.reduce(
      (total, stock) => total + (Number(stock.qty) || 1),
      0
    );

    if (mode === "edit") {
      const existingStock = safeSelected.find(
        (stock) => stock._id === data._id
      );
      if (existingStock) {
        if (data.type === "bullish") {
          totalBullishQty -= existingStock.qty;
        } else if (data.type === "bearish") {
          totalBearishQty -= existingStock.qty;
        }
      }
    }

    const singleAssetContest = isSingleAssetContest(contestDetails);

    if (singleAssetContest) {
      const projectedBullishQty =
        data.type === "bullish"
          ? totalBullishQty + formValue
          : totalBullishQty;
      const projectedBearishQty =
        data.type === "bearish"
          ? totalBearishQty + formValue
          : totalBearishQty;
      const requiredQty = contestDetails?.stock_quantity || 1;

      if (projectedBullishQty + projectedBearishQty > requiredQty) {
        toast.error(`You can only select ${requiredQty} asset for this contest`);
        return null;
      }
    } else {
      if (
        data.type === "bullish" &&
        totalBullishQty + formValue > contestDetails?.bulls
      ) {
        toast.error(
          `The Maximum Number of Bullish Assets allowed for this Fantasy is ${contestDetails.bulls}`
        );
        return null;
      }

      if (
        data.type === "bearish" &&
        totalBearishQty + formValue > contestDetails?.bears
      ) {
        toast.error(
          `The Maximum Number of Bearish Assets allowed for this Fantasy is ${contestDetails.bears}`
        );
        return null;
      }
    }
  }

  if (formValue <= 0) {
    return null;
  }

  return {
    _id: data?._id,
    name: data.name || "",
    ticker: data.ticker,
    qty: formValue,
    type: data.type,
    logo: data.logo,
    sector: data.sector,
    price: data.price,
    priceDifference: data?.priceDifference,
    priceDifferencePercentage: data?.priceDifferencePercentage,
  };
};

export const Modal = ({
  isActive,
  onClose,
  handleOk,
  title,
  data,
  children,
  selectedPortfoilo,
  contestDetails,
  mode,
  uniqueAssetSelection = false,
}) => {
  const [form, setForm] = useState({ value: 1 });
  console.log(contestDetails, "modal-contestDetails");
  console.log(mode, "mode*********");
  useEffect(() => {
    console.log(29, selectedPortfoilo);
    console.log(data, "data******");
    if (mode === "edit" && selectedPortfoilo?.length > 0) {
      const existingStock = selectedPortfoilo?.find(
        (item) => item._id === data._id
      );

      console.log("Existing Stock:", existingStock);

      if (existingStock) {
        setForm({ value: existingStock.qty || 1 });
      } else if (data?.qty) {
        setForm({ value: data.qty });
      } else {
        setForm({ value: 1 }); // Default value if stock is not in the portfolio
      }
    } else {
      setForm({ value: 1 }); // Default value when not in edit mode
    }
  }, [data, selectedPortfoilo, mode]);

  console.log(form, "form--");

  const handleChange = (event) => {
    console.log("***************", event);
    if (event === "plus") {
      setForm((prev) => {
        const current = Number(prev.value) || 0;
        return { ...prev, value: current + 1 };
      });
    } else if (event === "minus") {
      setForm((prev) => {
        const current = Number(prev.value) || 0;
        if (current <= 1) return prev;
        return { ...prev, value: current - 1 };
      });
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      setForm({ value: "" }); // Allow clearing the input for retyping
      return;
    }
    if (/^\d+$/.test(value) && Number(value) >= 1) {
      setForm({ value: parseInt(value, 10) });
    }
  };

  const handleSubmit = () => {
    console.log("okk", data);

    const payload = buildPortfolioStockPayload({
      data,
      qty: form.value,
      selectedPortfoilo,
      contestDetails,
      mode,
      uniqueAssetSelection,
    });

    if (payload) {
      handleOk(payload);
    }

    onClose();
    setForm({ value: 1 });
  };

  const skipQuantitySelection = shouldSkipQuantityModal(contestDetails, data?.type);

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      {data && (
        <div className="modal-content">
          <div className="modal-close" onClick={onClose}>
            <img src={Close} alt="Close" />
          </div>
          <h3 className="popup-title">{data.name}</h3>
          <div className="select-share-qty">
            {!skipQuantitySelection && !uniqueAssetSelection && (
            <div className="form-group">
              <label>Select Quantity</label>
              <div className="d-flex align-items-center justify-content-center inc-dec-num">
                <div
                  className="cursor-pointer"
                  onClick={() => handleChange("minus")}
                >
                  <img src={MinusIcon} alt="minus" />
                </div>
                <input
                  value={form.value}
                  type="text"
                  className="form-control"
                  placeholder="1"
                  onChange={handleInputChange}
                />
                <div
                  className="cursor-pointer"
                  onClick={() => handleChange("plus")}
                >
                  <img src={PlusIcon} alt="plus" />
                </div>
              </div>
            </div>
            )}
            {/* <div className="form-group">
          <img src={QtyOR} alt="or" className="mb-2" />
            <div className="date-field">
              <input
                type="text"
                className="form-control"
                placeholder="Amount"
              />
              <a>

                <p style={{fontSize: "14px"}}>Balance: $1,00,000</p>
              </a>
            </div>
          </div> */}
            {/* <p className="model-bullish-p1">
          You can buy maximum 0 stocks with this amount
          </p> */}
            <p className="model-bullish-p">{title}</p>
          </div>
          <div className="popup-cta">
            <div
              className="cta-btn cta-fill cta-lg cursor-pointer"
              onClick={handleSubmit}
            >
              Ok
            </div>
            {/* <Link to="/contest/lineup/crypto" className="cta-btn cta-fill cta-lg">
            Ok
          </Link> */}
          </div>
        </div>
      )}
    </div>
  );
};

export const StripeModal = ({
  isActive,
  onClose,
  title,
  children,
  onConfirm,
  data,
}) => {
  const handleConfirm = () => {
    onConfirm();

    onClose();
  };

  console.log(58, data, sessionStorage.getItem("client_secret"));

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title">Stripe</h3>
        {data && sessionStorage.getItem("client_secret") && (
          <StripeComponent data={data} onClose={onClose} />
        )}
      </div>
    </div>
  );
};

export const ConfirmationPorfoilo = ({
  isActive,
  onClose,
  title,
  children,
  onConfirm,
}) => {
  const [form, setForm] = useState({ name: "" });
  const handleConfirm = () => {
    if (form.name) {
      onConfirm({ name: form.name });
    } else {
      toast.warn("Please enter name");
    }
  };

  const handleClose = () => {
    // Clear the form when the modal is closed
    setForm({ name: "" });
    onClose();
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={handleClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title">Confirmation</h3>
        <div className="confirmation-popup">
          <div className="form-group second">
            <label>Portfoilo Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Portfolio Name"
              value={form.name}
              onChange={(event) => {
                setForm((prev) => ({ ...prev, name: event.target.value }));
              }}
            />
          </div>

          <div className="popup-cta mb-md-2">
            <Link
              className="cta-btn cta-fill cta-lg cursor-pointer"
              // to="/contest"
              onClick={handleConfirm}
            >
              Create Portfoilo
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ConfirmationModal = ({
  isActive,
  onClose,
  title,
  children,
  onConfirm,
  contestId,
  code,
  previewData,
  contestDetails,
  contestType,
  type,
}) => {
  const [walletHistory, setwalletHistory] = useState([]);
  const [isJoining, setIsJoining] = useState(false);

  const fetchWalletHistory = () => {
    Get(HttpService()?.walletHistory)
      .then((result) => {
        if (result?.status) {
          setwalletHistory(result?.data?.walletData);
          console.log(result, "walletHistory");
        } else {
          toast.error(result?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  useEffect(() => {
    fetchWalletHistory();
  }, []);

  const handleConfirm = () => {
    const joinContestData = {
      contest_id: contestId,
      code: code || "",
      stock_data: previewData.map((item) => ({
        stock_symbol_id: item._id,
        ticker: item.ticker,
        qty: item.qty,
        type: item.type,
        rally_bull_type: item.rally_bull_type,
      })),
      return_type: type === "fantasy" ? "fantasy" : "game",
      // ...(code ? { code: code } : {}),
    };

    const gameJoinContestData = {
      contest_id: String(contestDetails?.id || contestId),
      return_type: type === "fantasy" ? "fantasy" : "game",
      // code: code || '',
      stock_data: previewData.map((item) => ({
        stock_symbol_id: item._id,
        ticker: item.ticker,
        qty: item.qty,
        type: item.type,
        tier_id: item?.tier_id,
        rally_bull_type: "",
      })),
    };

    // { contest_id: contestId,  stock_data: previewData.map((item) => ({
    //   stock_symbol_id: item.companyProfile.stock_symbol_id,
    //   ticker: item.ticker,
    //   qty: item.qty,
    //   type: item.type,
    //   rally_bull_type: item.rally_bull_type,
    // })), }

    if (!isJoining) {
      setIsJoining(true);

      const apiEndpoint =
        contestDetails?.contest_type === "game"
          ? HttpService()?.joinGameContest
          : HttpService()?.joinContest;

      const payload =
        contestDetails?.contest_type === "game"
          ? gameJoinContestData
          : joinContestData;

      Postdata(apiEndpoint, payload)
        .then((response) => {
          console.log(response, "------------------");
          if (response?.status) {
            console.log(response.data, "	ContestDetails....");
            trackAFEvent(AF_EVENTS.MP_JOIN_CONTEST, {
              ...joinContestData,
              type: contestType,
              action: "join_game",
            });
            trackEvent(EVENTS.MP_JOIN_CONTEST, {
              ...joinContestData,
              type: contestType,
              action: "join_game",
            });
            onConfirm();

            onClose();
            toast.success(response?.message);
          } else {
            toast.error(response?.message);
          }
        })
        .catch((error) => {
          console.log("Error:------", error.message);
          toast.error(error?.response?.data?.message);
        });
    }
  };
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title">Confirmation</h3>
        <div className="confirmation-popup field-gray">
          <div className="form-group">
            <label>
              Joining {type === "fantasy" ? "Fantasy" : "Game"} with
            </label>
            <input
              type="text"
              className="form-control"
              disabled
              value={
                contestDetails?.title
                  ? contestDetails?.title
                  : "Rally Bulls Game"
              }
            />
          </div>
          <ul className="confirm-amt-list">
            <li>
              <span>Current Balance</span>
              <span>
                <img src={GreenCoin} alt="Greencoin" />
                {walletHistory[0]?.closing_balance
                  ? Number(
                      walletHistory[0]?.closing_balance.toFixed(0)
                    ).toLocaleString("en-US")
                  : 0}
              </span>
            </li>
            <li>
              <span>Joining Amount</span>
              <span>
                {contestDetails?.entry_fees === 0 ? (
                  "Free"
                ) : (
                  <>
                    <img src={GreenCoin} alt="Greencoin" />
                    {contestDetails?.entry_fees}
                  </>
                )}
              </span>
            </li>
          </ul>
          <div className="popup-note">
            By joining {type === "fantasy" ? "fantasy" : "game"}, you accept
            Rally Bulls
            <a
              href="https://rallybulls.com/terms-and-conditions/"
              target="_blank"
              className="ms-1"
            >
              Terms & Conditions
            </a>
          </div>
          <div className="popup-cta mb-md-2">
            <div
              className="cta-btn cta-fill cta-lg cursor-pointer"
              // to="/contest"
              onClick={handleConfirm}
            >
              {/* Join Game */}
              {isJoining
                ? "Joining..."
                : type === "fantasy"
                ? "Join Fantasy"
                : "Join Game"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ConfirmationFantasyModal = ({
  isActive,
  onClose,
  title,
  children,
  onConfirm,
  fantasyId,
  code,
  previewData,
  contestDetails,
  fantasyType,
  type,
  roasterAssets,
  roasterStockData,
}) => {
  const [walletHistory, setwalletHistory] = useState([]);
  const [isJoining, setIsJoining] = useState(false);
  console.log(fantasyType, "-----fantasyType");
  const fetchWalletHistory = () => {
    Get(HttpService()?.walletHistory)
      .then((result) => {
        if (result?.status) {
          setwalletHistory(result?.data?.walletData);
          console.log(result, "walletHistory");
        } else {
          toast.error(result?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  useEffect(() => {
    fetchWalletHistory();
  }, []);

  const handleConfirm = () => {
    const rawRoster =
      roasterAssets && roasterAssets.length > 0
        ? roasterAssets
        : roasterStockData && roasterStockData.length > 0
        ? [...(previewData || []), ...(roasterStockData || [])]
        : previewData || [];

    const seenRosterIds = new Set();
    const uniqueRoster = [];
    for (const item of rawRoster) {
      const id = (item?._id || item?.stock_symbol_id)?.toString();
      if (id && !seenRosterIds.has(id)) {
        seenRosterIds.add(id);
        uniqueRoster.push(item);
      }
    }

    const joinFantasyData = {
      fantasy_id: fantasyId,
      // code: code || '',
      stock_data: previewData
        ?.filter(
          (item) =>
            item?.qty &&
            (item?.type === "bullish" || item?.type === "bearish")
        )
        .map((item) => ({
          stock_symbol_id: item?._id || item?.stock_symbol_id,
          ticker: item?.ticker,
          qty: item?.qty,
          type: item?.type,
          rally_bull_type: item?.rally_bull_type,
          bench_stock: 0,
        })),
      roaster_assets: uniqueRoster.map((item) => ({
        stock_symbol_id: item?._id || item?.stock_symbol_id,
        ticker: item?.ticker,
      })),
      // ...(fantasyType === "private" ? { code: code || '' } : {}),
    };

    // { contest_id: fantasyId,  stock_data: previewData.map((item) => ({
    //   stock_symbol_id: item.companyProfile.stock_symbol_id,
    //   ticker: item.ticker,
    //   qty: item.qty,
    //   type: item.type,
    //   rally_bull_type: item.rally_bull_type,
    // })), }

    if (!isJoining) {
      setIsJoining(true);

      Postdata(HttpService()?.joinFantasy, joinFantasyData)
        .then((response) => {
          setIsJoining(false);
          console.log(response, "------------------");
          if (response?.status) {
            console.log(response.data, "	ContestDetails....");
            trackAFEvent(AF_EVENTS.MP_JOIN_FANTASY, {
              ...joinFantasyData,
              // type: fantasyType,
              action: "join_fantasy",
            });
            trackEvent(EVENTS.MP_JOIN_FANTASY, {
              ...joinFantasyData,
              // type: fantasyType,
              action: "join_fantasy",
            });
            onConfirm();

            onClose();
            toast.success(response?.message);
          } else {
            toast.error(response?.message);
          }
        })
        .catch((error) => {
          setIsJoining(false);
          console.log("Error:------", error.message);
          toast.error(error?.response?.data?.message);
        });
    }
  };
  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title">Confirmation</h3>
        <div className="confirmation-popup field-gray">
          <div className="form-group">
            <label>Joining Fantasy with</label>
            <input
              type="text"
              className="form-control"
              disabled
              value={
                contestDetails?.title
                  ? contestDetails?.title
                  : "Rally Bulls fantasy"
              }
            />
          </div>
          <ul className="confirm-amt-list">
            <li>
              <span>Current Balance</span>
              <span>
                <img src={GreenCoin} alt="Greencoin" />
                {walletHistory[0]?.closing_balance
                  ? Number(
                      walletHistory[0]?.closing_balance.toFixed(0)
                    ).toLocaleString("en-US")
                  : 0}
              </span>
            </li>
            <li>
              <span>Joining Amount</span>
              <span>
                {contestDetails?.entry_fees === 0 ? (
                  "Free"
                ) : (
                  <>
                    <img src={GreenCoin} alt="Greencoin" />
                    {contestDetails?.entry_fees}
                  </>
                )}
              </span>
            </li>
          </ul>
          <div className="popup-note">
            By joining {type === "fantasy" ? "fantasy" : "game"}, you accept
            Rally Bulls
            <a
              href="https://rallybulls.com/terms-and-conditions/"
              target="_blank"
              className="ms-1"
            >
              Terms & Conditions
            </a>
          </div>
          <div className="popup-cta mb-md-2">
            <div
              className="cta-btn cta-fill cta-lg cursor-pointer"
              // to="/contest"
              onClick={handleConfirm}
            >
              {/* Join Contest */}
              {isJoining ? "Joining..." : "Join Fantasy"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// export const ConfirmationFantasyModal = ({
//   isActive,
//   onClose,
//   title,
//   children,
//   onConfirm,
// }) => {
//   const handleConfirm = () => {
//     onConfirm();

//     onClose();
//   };
//   return (
//     <div className={`modal ${isActive ? "active" : ""}`}>
//       <div className="modal-content">
//         <div className="modal-close" onClick={onClose}>
//           <img src={Close} alt="Close" />
//         </div>
//         <h3 className="popup-title">Confirmation</h3>
//         <div className="confirmation-popup field-gray">
//           <div className="form-group">
//             <label>Joining League with</label>
//             <input
//               type="text"
//               className="form-control"
//               value="RB 6 People 4 Round League"
//             />
//           </div>
//           <div className="form-group second">
//             <label>Portfolio Name</label>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Enter Porfolio Name"
//             />
//           </div>
//           <ul className="confirm-amt-list">
//             <li>
//               <span>Current Balance</span>
//               <span>
//                 <img src={GreenCoin} alt="Greencoin" />
//                 9500
//               </span>
//             </li>
//             <li>
//               <span>Joining Amount</span>
//               <span>
//                 <img src={GreenCoin} alt="Greencoin" />
//                 50
//               </span>
//             </li>
//           </ul>
//           <div className="popup-note">
//             By joining contest, you accept Rally Bulls
//             <Link to="#">Terms & Conditions</Link>
//           </div>
//           <div className="popup-cta mb-md-2">
//             <Link
//               className="cta-btn cta-fill cta-lg"
//               // to="/contest"
//               onClick={handleConfirm}
//             >
//               Join League
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

export const InvestmentResearchModal = ({
  isActive,
  onClose,
  title,
  // onClick,
}) => {
  const navigate = useNavigate();

  const onClick = (value) => {
    navigate("/home/marketPreview", {
      state: { stockType: value },
    });
    onClose();
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content success-popup">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title mb-3">Select Asset Type</h3>
        <div className="popup-cta">
          <button className="btn-inv" onClick={() => onClick("stocks")}>
            <div className="title">
              <img src={IR1} />
              Stocks
            </div>
            <img src={RightAerrow} />
          </button>
        </div>
        <div className="popup-cta">
          <button className="btn-inv" onClick={() => onClick("crypto")}>
            <div className="title">
              <img src={IR2} />
              Crypto
            </div>
            <img src={RightAerrow} />
          </button>
        </div>
        <div className="popup-cta">
          <button className="btn-inv" onClick={() => onClick("ETF")}>
            <div className="title">
              <img src={IR3} />
              ETFs - Exchange-traded funds
            </div>
            <img src={RightAerrow} />
          </button>
        </div>
        {/* <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Ok
          </button>
        </div> */}
      </div>
    </div>
  );
};

export const CompanyFilterModal = ({
  isActive,
  onClose,
  title,
  handleFilterChange,
  // onClick,
}) => {
  const navigate = useNavigate();

  const onClick = (value) => {
    handleFilterChange(value);
    onClose();
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content success-popup">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title mb-3">Select Asset Type</h3>
        <div className="popup-cta">
          <button className="btn-inv" onClick={() => onClick("stocks")}>
            <div className="title">
              <img src={IR1} />
              Stocks
            </div>
            <img src={RightAerrow} />
          </button>
        </div>
        <div className="popup-cta">
          <button className="btn-inv" onClick={() => onClick("crypto")}>
            <div className="title">
              <img src={IR2} />
              Crypto
            </div>
            <img src={RightAerrow} />
          </button>
        </div>
        <div className="popup-cta">
          <button className="btn-inv" onClick={() => onClick("ETF")}>
            <div className="title">
              <img src={IR3} />
              ETFs - Exchange-traded funds
            </div>
            <img src={RightAerrow} />
          </button>
        </div>
        {/* <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Ok
          </button>
        </div> */}
      </div>
    </div>
  );
};

export const SuccessModal = ({
  isActive,
  onClose,
  title,
  children,
  contestType,
  code,
  CreateContest,
  CreateFantasy,
  type,
  typeOf, //public - private
  // onClick,
}) => {
  const navigate = useNavigate();

  const onClick = () => {
    if ((CreateContest || CreateFantasy) && typeOf === "private") {
      navigate("/fantasy/invite-friend", {
        state: { InviteCode: code, CreateFantasy: CreateFantasy },
      });
      if (CreateFantasy) {
        localStorage.setItem("CreateFantasy", JSON.stringify(false));
      } else {
        localStorage.setItem("CreateContest", JSON.stringify(false));
      }
      onClose();
    } else if (type === "fantasy") {
      const weekMode = localStorage.getItem("weekMode");
      if (weekMode === "true" || weekMode === true) {
        localStorage.setItem("weekMode", false);
        navigate("/fantasy/myfantasy/multi-round/matchup");
      } else {
        navigate("/fantasy/myfantasy/upcoming");
      }
      onClose();
    } else {
      navigate("/contest/mycontest/upcoming");
      onClose();
    }
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content success-popup">
        {/* <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div> */}
        <div className="icon-wrap">
          <img src={Success} alt="Success" />
        </div>
        <h3 className="popup-title">Success</h3>
        <p>{title}</p>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export const CreateFantasyModal = ({
  isActive,
  onClose,
  title,
  children,
  contestType,
}) => {
  const navigate = useNavigate();
  const [selectedFantasy, setSelectedFantasy] = useState(""); // 'single' or 'multi'

  const handleSelect = (type) => {
    setSelectedFantasy(type);
  };

  const onClick = () => {
    if (selectedFantasy === "single") {
      navigate("/fantasy/create");
      onClose();
      setSelectedFantasy("");
    } else if (selectedFantasy === "multi") {
      navigate("/fantasy/multi-round/create");
      onClose();
      setSelectedFantasy("");
    } else {
      // optional: show warning if nothing is selected
      alert("Please select a fantasy type");
    }
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content success-popup">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <h3 className="popup-title mb-3">Select Fantasy Type</h3>
        <div
          className={`create-card ${
            selectedFantasy === "single" ? "selected" : ""
          }`}
          onClick={() => handleSelect("single")}
        >
          <p>Single Round Fantasy</p>
        </div>
        <div
          className={`create-card ${
            selectedFantasy === "multi" ? "selected" : ""
          }`}
          onClick={() => handleSelect("multi")}
        >
          <p>Multi Round Fantasy</p>
        </div>
        <div className="popup-cta">
          <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export const FantasyFullModal = ({
  isActive,
  onClose,
  title,
  type,
  // onClick,
}) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate("/fantasy");
    onClose();
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content success-popup">
        {/* <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div> */}
        <div className="icon-wrap">
          <img style={{ width: "20%" }} src={Like} alt="Success" />
        </div>
        {/* <h3 className="popup-title">Upgrade Plan</h3> */}
        {/* <p className="px-2">Please upgrade your plan to participate in more {type === 'fantasy' ? "fantasy" : "contest"} and ace to the leaderboard.</p> */}
        <p className="px-2 mt-3">
          🔥 The arena is set, and the contenders are locked in—this {title}{" "}
          Fantasy League is now FULL! 🚀🏆 But don’t worry, you can create a new
          Private {title} Fantasy League and invite your friends to join the
          action! 🎉🔥
        </p>
        <div className="popup-cta mt-2">
          <button
            className="cta-btn cta-fill cta-lg"
            style={{ fontSize: "15px" }}
            onClick={onClick}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export const AlertUpgradePlanModal = ({
  isActive,
  onClose,
  title,
  userPlanExistedCount,
  type,
  // onClick,
}) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate("/home/profile/plus");
    onClose();
  };

  return (
    <div className={`modal ${isActive ? "active" : ""}`}>
      <div className="modal-content success-popup">
        <div className="modal-close" onClick={onClose}>
          <img src={Close} alt="Close" />
        </div>
        <div className="icon-wrap">
          <img src={AlertIcon} alt="Success" />
        </div>
        <h3 className="popup-title">Upgrade Plan</h3>
        {/* <p className="px-2">Please upgrade your plan to participate in more {type === 'fantasy' ? "fantasy" : "contest"} and ace to the leaderboard.</p> */}
        <p className="px-2 mt-2">
          You already joined{" "}
          <span style={{ fontWeight: "700" }}>{userPlanExistedCount}</span> free{" "}
          {type === "fantasy" ? "fantasy" : "contest"} as per your plan!
        </p>
        <div className="popup-cta mt-2">
          <button className="cta-btn cta-fill cta-lg" onClick={onClick}>
            Upgrade Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export const CreateQueryString = (params) => {
  return Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");
};

export const CopyText = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    // setCopied(true);
    toast.success("Copied..!");
  });
};

export const sliderSettings = (slidesToShow) => ({
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: slidesToShow,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000, // Change this value to adjust the speed
  pauseOnHover: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
});

export function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ display: "none" }} onClick={onClick} />
  );
}

export function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ display: "none" }} onClick={onClick} />
  );
}

export const ConvertToDMY = (date) => {
  if (!date) return "";

  // Parse as UTC
  const momentDate = moment.utc(date);

  if (!momentDate.isValid()) return "";

  // Format the UTC date
  return momentDate.format("MM/DD/YYYY");
  // if (!date) return "";
  // return <Moment format="MM/DD/YYYY">{new Date(date)}</Moment>;
};

export const FantasyContestDates = ({ startDate, endDate }) => {
  const startLabel = ConvertToDMY(startDate);
  const endLabel = ConvertToDMY(endDate);
  if (!startLabel && !endLabel) return null;

  return (
    <div className="fantasy-contest-dates">
      {startLabel ? (
        <span>
          <span className="fantasy-contest-dates-label">Start Date</span>
          {startLabel}
        </span>
      ) : null}
      {endLabel ? (
        <span>
          <span className="fantasy-contest-dates-label">End Date</span>
          {endLabel}
        </span>
      ) : null}
    </div>
  );
};

// convert 0 = false & 1 = true
export const ConvertBoolean = (value) => {
  const isFalse = value === 0 ? false : true;
  return isFalse;
};

export const getTime = (date) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // return new Date(date).getUTCMonth()
  return `${new Date(date).getDate()} ${
    months[new Date(date).getMonth()]
  } ${new Date(date).getFullYear()}`;
};

export const isMarketOpeningWindow = () => {
  const now = new Date();
  const estTimeStr = now.toLocaleString("en-US", { timeZone: "America/New_York" });
  const estTime = new Date(estTimeStr);
  const hours = estTime.getHours();
  const minutes = estTime.getMinutes();
  const day = estTime.getDay();

  // Weekend (0 = Sunday, 6 = Saturday)
  if (day === 0 || day === 6) return false;

  // 9:30 AM to 9:36 AM EST
  if (hours === 9 && minutes >= 30 && minutes <= 36) {
    return true;
  }
  return false;
};


export const isMarketOpen = () => {
  const now = new Date();
  const estTimeStr = now.toLocaleString("en-US", { timeZone: "America/New_York" });
  const estTime = new Date(estTimeStr);
  const hours = estTime.getHours();
  const minutes = estTime.getMinutes();
  const day = estTime.getDay();

  // Weekend (0 = Sunday, 6 = Saturday)
  if (day === 0 || day === 6) return false;

  const currentTime = hours * 60 + minutes;
  const marketOpenTime = 9 * 60 + 30; // 9:30 AM in NY
  const marketCloseTime = 16 * 60;    // 4:00 PM in NY

  return currentTime >= marketOpenTime && currentTime <= marketCloseTime;
};

